<template>
  <div class="page_section">
    <div class="page_section__header">
      <p class="page_section__title t-h--2">
        <slot name="title"></slot>

        <template v-if="!this.$slots.title">
          {{ title }}
        </template>
      </p>

      <div class="page_section__controls" v-if="!!$slots.controls">
        <slot name="controls"> </slot>
      </div>
    </div>

    <div class="page_section__body">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.page_section {
  position: relative;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &__header {
    padding: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #d0d0d0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__body {
    padding: 8px;
  }
}
</style>
